var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-info flex"},[_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm._f("num")(_vm.value)))]),_c('div',{staticClass:"unit text-labelColor"},[_vm._v(_vm._s(_vm.unit))])])
}
var staticRenderFns = []

export { render, staticRenderFns }